import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TrialSubscriptionService } from '../trial-subscription.service';
import { AlertComponent } from '../../alert/alert.component';

declare var $: any;

@Component({
  selector: 'app-create-trial-user',
  templateUrl: './create-trial-user.component.html',
  styleUrls: ['./create-trial-user.component.css']
})
export class CreateTrialUserComponent implements OnInit {
  trialUserForm: FormGroup;
  pattern = "^[a-zA-Z0-9][a-zA-Z0-9\-\_\/. ]*[a-zA-Z.]+[a-zA-Z0-9]*$";
  
  // Hardcoded values
  private readonly HARDCODED_VALUES = {
    DIN: '12345678',
    Roles: [  
      { RoleName: 'Trial', RoleId: '68e78fc32eb488224ca8c86b' }
    ],
    NotificationType: ['Email', 'SMS', 'Browser', 'Ipad'],
    isRemoveRocketChat: false
  };
  
  // Dropdown options
  titleList = [
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Mrs.', label: 'Mrs.' },
    { value: 'Ms.', label: 'Ms.' },
    { value: 'Dr.', label: 'Dr.' },
    { value: 'Prof.', label: 'Prof.' }
  ];
  
  directorTypesList = [
    { value: 'Executive', label: 'Executive Director' },
    { value: 'NonExecutive', label: 'Non-Executive Director' },
    { value: 'Independent', label: 'Independent Director' },
    { value: 'Nominee', label: 'Nominee Director' }
  ];
  
  boardDesignationlist = [
    { value: 'Chairman', label: 'Chairman' },
    { value: 'ViceChairman', label: 'Vice Chairman' },
    { value: 'ManagingDirector', label: 'Managing Director' },
    { value: 'Director', label: 'Director' }
  ];
  
  kmpDesignationList = [
    { value: 'CEO', label: 'Chief Executive Officer' },
    { value: 'CFO', label: 'Chief Financial Officer' },
    { value: 'COO', label: 'Chief Operating Officer' },
    { value: 'CTO', label: 'Chief Technology Officer' },
    { value: 'CSO', label: 'Company Secretary' }
  ];
  
  executiveDesignationlist = [
    { value: 'VP', label: 'Vice President' },
    { value: 'AVP', label: 'Assistant Vice President' },
    { value: 'GM', label: 'General Manager' },
    { value: 'DGM', label: 'Deputy General Manager' },
    { value: 'Manager', label: 'Manager' }
  ];
  
  nonExecutiveDesignationlist = [
    { value: 'SeniorManager', label: 'Senior Manager' },
    { value: 'Manager', label: 'Manager' },
    { value: 'AssistantManager', label: 'Assistant Manager' },
    { value: 'Executive', label: 'Executive' },
    { value: 'Officer', label: 'Officer' }
  ];
  
  categoryList = [
    { value: 'Promoter', label: 'Promoter' },
    { value: 'NonPromoter', label: 'Non-Promoter' },
    { value: 'Public', label: 'Public' }
  ];

  constructor(
    private fb: FormBuilder,
    private userMasterService: TrialSubscriptionService,
    private router: Router,
    private route: ActivatedRoute,
    private alert: AlertComponent
  ) { }

  ngOnInit(): void {
    this.trialUserForm = this.fb.group({
      // User Type and Basic Info
      TypeOfUser: new FormControl({value: 'BoardMember', disabled: true}, [Validators.required]),
      TitleName: new FormControl('', []),
      FirstName: new FormControl('', [Validators.required, Validators.pattern(this.pattern)]),
      LastName: new FormControl('', [Validators.required, Validators.pattern(this.pattern)]),
      
      // Contact Information
      EmailId: new FormControl('', [Validators.required, Validators.email]),
      SecondaryEmailId: new FormControl('', []),
      MobileNumber: new FormControl('', [Validators.required, Validators.pattern("[0-9]{10}")]),
      MobileNumber2: new FormControl('', [Validators.pattern("[0-9]{10}")]),
      
      // Professional Information
      Designation: new FormControl('', [Validators.minLength(5), Validators.maxLength(500), Validators.pattern(this.pattern)]),
      DesignationSelection: new FormControl('', [Validators.required]),
      DirectorType: new FormControl('', [Validators.required]),
      AreaofExpertise: new FormControl('', [ Validators.minLength(5), Validators.pattern("^[a-zA-Z\\s]+$")]),
      Experience: new FormControl('', []),
      
      // Personal Information
      DOB: new FormControl('', []),
      Remuneration: new FormControl('', []),
      
      // Company Information
   
      CompanyId: new FormControl('', []),
      
      // Role and Permissions
      RoleName: new FormControl({value: 'Trial', disabled: true}, [Validators.required]),
      ReportToUser: new FormControl('', []),
      
      // Additional Information
      PAN: new FormControl('', [Validators.required, Validators.pattern("[A-Z]{5}[0-9]{4}[A-Z]{1}")]),
      DIN: new FormControl({value: this.HARDCODED_VALUES.DIN, disabled: true}, []),
      Gender: new FormControl('', []),
      Category: new FormControl('', []),
      
      // Notification Preferences
      SMSNotification: new FormControl(false, []),
      EmailNotification: new FormControl(true, []),
      BellNotification: new FormControl(false, []),
      IPADNotification: new FormControl(true, []),
      BrowserNotification: new FormControl(true, [])
    });
    
    // ============================================================
    // STEP 4: Read URL parameters and auto-fill user details
    // ============================================================
    this.route.queryParams.subscribe(params => {
      const urlParams = {
        email: params['email'] || '',
        firstName: params['firstName'] || '',
        lastName: params['lastName'] || '',
        phone: params['phone'] || ''
      };
      
      console.log('User form - URL Parameters received:', urlParams);
      
      // Auto-fill form fields if parameters exist
      if (urlParams.email || urlParams.firstName || urlParams.lastName || urlParams.phone) {
        this.trialUserForm.patchValue({
          FirstName: urlParams.firstName,
          LastName: urlParams.lastName,
          EmailId: urlParams.email,
          MobileNumber: urlParams.phone
        });
        
        console.log('Auto-filled user form with URL parameters');
        
        // Show a friendly notification
        if (urlParams.email) {
          console.log(`Welcome back! We've pre-filled your information from the email link.`);
        }
      }
    });
  }

  onSubmit() {
    console.log('onSubmit called');
    console.log('Form valid:', this.trialUserForm.valid);
    console.log('Form errors:', this.getFormValidationErrors());
    
    if (this.trialUserForm.valid) {
      // getRawValue() includes disabled fields
      const formData = this.trialUserForm.getRawValue();
      
      // Construct payload matching the API requirements
      const payload = {
        FirstName: formData.FirstName,
        LastName: formData.LastName,
        EmailId: formData.EmailId,
        MobileNumber: formData.MobileNumber,
        PAN: formData.PAN || '',
        DIN: this.HARDCODED_VALUES.DIN, // hardcoded
        Title: formData.TitleName || '',
        Gender: formData.Gender,
        Experience: parseInt(formData.Experience) || 0,
        AreaOfExpertise: formData.AreaofExpertise || '',
        TypeOfUser: formData.TypeOfUser,
        Roles: this.HARDCODED_VALUES.Roles, // hardcoded
        NotificationType: this.HARDCODED_VALUES.NotificationType, // hardcoded
        isRemoveRocketChat: this.HARDCODED_VALUES.isRemoveRocketChat // hardcoded
      };
      
      console.log('Payload:', payload);
      
      // Call the API using UserMasterService
      this.userMasterService.addUserTrial(payload)
        .then((response: any) => {
          console.log('API Response:', response);
          const status = response?.status ?? response?.data?.status ?? response?.result?.status;
          const message = response?.message || response?.data?.message || response?.result?.message || 'Operation completed.';

          if (status === 0) {
            this.alert.successWithOk1('User created successfully! Redirecting to login page...', () => {
              // Clean up any lingering modal state before navigation
              $('body').removeClass('modal-open');
              $('.modal-backdrop').remove();
              this.router.navigate(['/login']);
            });
          } else {
            this.alert.error1(message || 'Failed to create user.');
          }
        })
        .catch((error: any) => {
          console.error('Error Response:', error);
          this.alert.error1('Failed to create user. Please try again.');
        });
    } else {
      this.alert.error1('Please fill in all required fields correctly.');
    }
  }

  onChangeUserType() {
    // Handle user type change logic
    const userType = this.trialUserForm.get('TypeOfUser')?.value;
    
    // Clear designation selection when user type changes
    this.trialUserForm.get('DesignationSelection')?.setValue('');
    this.trialUserForm.get('DirectorType')?.setValue('');
    
    // Set validators based on user type
    if (userType === 'BoardMember') {
      this.trialUserForm.get('DesignationSelection')?.setValidators([Validators.required]);
      this.trialUserForm.get('DirectorType')?.setValidators([Validators.required]);
    } else if (userType === 'KMP') {
      this.trialUserForm.get('DesignationSelection')?.setValidators([Validators.required]);
    } else {
      this.trialUserForm.get('Designation')?.setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(500), Validators.pattern(this.pattern)]);
    }
    
    this.trialUserForm.get('DesignationSelection')?.updateValueAndValidity();
    this.trialUserForm.get('DirectorType')?.updateValueAndValidity();
    this.trialUserForm.get('Designation')?.updateValueAndValidity();
  }

  onChangeAddUser() {
    // Handle new/existing user logic
  }

  onSelectedDirectorType(event: any) {
    // Handle director type selection
  }

  // Helper method to get all form validation errors
  getFormValidationErrors() {
    const errors: any = {};
    Object.keys(this.trialUserForm.controls).forEach(key => {
      const controlErrors = this.trialUserForm.get(key)?.errors;
      if (controlErrors) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }
}